export default __webpack_public_path__ + "img/fc68dfcd5492a23da8f039771915479b.svg";